exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-container{text-align:center;width:80%;top:50%;left:50%;position:absolute;transform:translate(-50%,-50%)}.loading-container .phrase{padding-top:20px;margin-bottom:20px;font-weight:100}.loading-container .phrase p{font-size:2.8rem;margin-bottom:5px}.loading-container .phrase small{font-size:2rem}.loading-container .sk-cube:before{background-color:#bc3f26}.loading-container i{font-size:3rem}.loading-container .spinner{width:100px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/css/loading.less
 ** module id = 779
 ** module chunks = 0
 **/